import { defineComponent as l, computed as o } from "vue";
import { calculateAvailability as r } from "./td-longtail-vue-components87.js";
const p = /* @__PURE__ */ l({
  __name: "availability-information",
  props: {
    availability: {
      type: Object,
      require: !0,
      default: () => {
      }
    },
    isPresale: {
      type: Boolean
    }
  },
  setup(t, { expose: i }) {
    const a = t, e = o(() => r(a.availability, a.isPresale));
    return i({ availableState: e }), { __sfc: !0, props: a, availableState: e };
  }
});
export {
  p as default
};
